<template>
  <div
    class="exhibitionMade"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale">Art exhibition and sale</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Customization</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMadeContent">
      <div class="section">
        <el-form
          ref="madeForm"
          :rules="rules"
          class="madeForm za_madeForm"
          :model="madeForm"
          label-width="120px"
        >
          <el-form-item
            label="Customization Type："
            prop="category"
            class="item"
          >
            <el-select
              v-model="madeForm.category"
              placeholder="Please select a custom type"
              clearable
            >
              <el-option label="唐卡" value="1"></el-option>
              <el-option label="泥塑" value="2"></el-option>
              <el-option label="壁画" value="3"></el-option>
              <el-option label="堆绣" value="4"></el-option>
              <el-option label="彩绘" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Custom theme：" prop="theme" class="item">
            <el-input
              v-model="madeForm.theme"
              placeholder="Please input the theme"
            ></el-input>
          </el-form-item>
          <el-form-item label="Custom size：" prop="size" class="item">
            <el-input
              v-model="madeForm.size"
              placeholder="Please enter the size"
            ></el-input>
          </el-form-item>
          <el-form-item label="Painting academy：" prop="paintingId">
            <el-select v-model="madeForm.paintingId" clearable filterable placeholder="Painting academy" @change="changePainting">
              <el-option
                v-for="item in paintingList"
                :key="item.id"
                :label="item.englishName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Creator：" prop="inheritorId" v-if="madeForm.paintingId">
            <el-select v-model="madeForm.inheritorId" clearable filterable placeholder="Please select the creator">
              <el-option
                v-for="item in inheritorList"
                :key="item.id"
                :label="item.englishName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="Creator：" prop="author" class="item">
            <el-input
              v-model="madeForm.author"
              placeholder="Please enter the creative author"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="Expected price："
            prop="expectPrice"
            class="item"
          >
            <el-input
              v-model="madeForm.expectPrice"
              placeholder="Please enter the expected price"
            ></el-input>
          </el-form-item>
          <div class="line"></div>
          <el-form-item label="Customer name：" prop="customer" class="item">
            <el-input
              v-model="madeForm.customer"
              placeholder="Please enter your name"
            ></el-input>
          </el-form-item>
          <el-form-item label="Contact Information：" prop="phone" class="item">
            <el-input
              v-model="madeForm.phone"
              placeholder="Please enter contact information"
            ></el-input>
          </el-form-item>
          <el-form-item label="Remarks：" prop="textarea" class="item">
            <el-input
              type="textarea"
              v-model="madeForm.textarea"
              placeholder="Please fill in the remarks"
            ></el-input>
          </el-form-item>
          <div class="button eng_button">
            <span @click="onSubmit('madeForm')"
              >Send Customization Requirements</span
            >
          </div>
        </el-form>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Contact Number：{{contactPhone}}</div>
      <div class="tel">Email：{{contactEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>Contact art studio</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="exhibitionMade" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >སྒྱུ་རྩལ་བརྩམས་ཆོས་འགྲེམ་འཚོང་།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">གཏན་ཁེལ།</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMadeContent">
      <div class="section">
        <el-form
          ref="madeForm"
          :rules="rules"
          class="madeForm za_madeForm"
          :model="madeForm"
          label-width="120px"
        >
          <el-form-item label="འདེམས་བཟོའི་རིགས་དབྱེ།：" prop="category">
            <el-select
              v-model="madeForm.category"
              placeholder="རོགས་།སྒྲིག་སྲོལ་རིགས་འདེམས་།"
              clearable
            >
              <el-option label="ཐང་ག" value="1"></el-option>
              <el-option label="འཇིམ་བཟོ། " value="2"></el-option>
              <el-option label="ལྡེབས་རིས།" value="3"></el-option>
              <el-option label="དྲས་དྲུབ།" value="4"></el-option>
              <el-option label="ཚོན་རིས།" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" བསྟན་བྱ་གཏན་འཁེལ། །：" prop="theme">
            <el-input
              v-model="madeForm.theme"
              placeholder="བརྗོད་བྱ་རོགས་།"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ཆེ་ཆུང་གཏན་ཁེལ།：" prop="size">
            <el-input
              v-model="madeForm.size"
              placeholder="ཆེ་ཆུང་རོགས་།"
            ></el-input>
          </el-form-item>
          <el-form-item label="ཁོངས་གཏོགས་རི་མོ་ཁང་：" prop="paintingId">
            <el-select v-model="madeForm.paintingId" clearable filterable placeholder="ཁོངས་གཏོགས་ཀྱི་རི་མོ་ཁང་འདེམས་རོགས་།" @change="changePainting">
              <el-option
                v-for="item in paintingList"
                :key="item.id"
                :label="item.zangName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="གསར་རྩོམ་བྱེད་མཁན་རྩོམ་པ་པོ་：" prop="inheritorId" v-if="madeForm.paintingId">
            <el-select v-model="madeForm.inheritorId" clearable filterable placeholder="གསར་རྩོམ་བྱེད་མཁན་འདེམས་རོགས་།">
              <el-option
                v-for="item in inheritorList"
                :key="item.id"
                :label="item.zangName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label=" གསར་རྩོམ་མཁན།་：" prop="author">
            <el-input
              v-model="madeForm.author"
              placeholder="གསར་རྩོམ་རྩོམ་པ་པོ་རོགས་།"
            ></el-input>
          </el-form-item> -->
          <el-form-item label=" སྔོན་དཔག་རིན་གོང་།：" prop="expectPrice">
            <el-input
              v-model="madeForm.expectPrice"
              placeholder="སྔོན་དཔག་རིན་གོང་རོགས་།"
            ></el-input>
          </el-form-item>
          <div class="line"></div>
          <el-form-item label=" མགྲོན་པོའི་རུས་མིང་།：" prop="customer">
            <el-input
              v-model="madeForm.customer"
              placeholder="མིང་འབྲི་རོགས།"
            ></el-input>
          </el-form-item>
          <el-form-item label="འབྲེལ་གཏུགས་བྱེད་ཐབས།：" prop="phone">
            <el-input
              v-model="madeForm.phone"
              placeholder="འབྲེལ་གཏུག་བྱེད་སྟངས་ནང་འཇུག་རོགས་།"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ཟུར་བཀོད།：" prop="textarea">
            <el-input
              type="textarea"
              v-model="madeForm.textarea"
              placeholder="གསལ་བཤད་འབྲི་རོགས།"
            ></el-input>
          </el-form-item>
          <div class="button">
            <span @click="onSubmit('madeForm')">
              འདེམས་བཟོའི་དགོས་མཁོའི་མཁོ་སྤྲོད།</span
            >
          </div>
        </el-form>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{contactPhone}}</div>
      <div class="tel">སྦྲགས་ཡིག：{{contactEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>འབྲེལ་གཏུག་</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="exhibitionMade" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionMadeTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale">艺术品展销</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">定制</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMadeContent">
      <div class="section">
        <el-form
          ref="madeForm"
          :rules="rules"
          class="madeForm"
          :model="madeForm"
          label-width="120px"
        >
          <el-form-item label="定制类型：" prop="category">
            <el-select
              v-model="madeForm.category"
              placeholder="请选择定制类型"
              clearable
            >
              <el-option label="唐卡" value="1"></el-option>
              <el-option label="泥塑" value="2"></el-option>
              <el-option label="壁画" value="3"></el-option>
              <el-option label="堆绣" value="4"></el-option>
              <el-option label="彩绘" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定制题材：" prop="theme">
            <el-input
              v-model="madeForm.theme"
              placeholder="请输入题材"
            ></el-input>
          </el-form-item>
          <el-form-item label="定制尺寸：" prop="size">
            <el-input
              v-model="madeForm.size"
              placeholder="请输入尺寸"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属画院：" prop="paintingId">
            <el-select v-model="madeForm.paintingId" clearable filterable placeholder="请选择所属画院" @change="changePainting">
              <el-option
                v-for="item in paintingList"
                :key="item.id"
                :label="item.chineseName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创作作者：" prop="inheritorId" v-if="madeForm.paintingId">
            <el-select v-model="madeForm.inheritorId" clearable filterable placeholder="请选择创作作者">
              <el-option
                v-for="item in inheritorList"
                :key="item.id"
                :label="item.chineseName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预期价格：" prop="expectPrice">
            <el-input
              @keydown.native="handleInput"
              v-model="madeForm.expectPrice"
              type="number"
              placeholder="请输入预期价格"
            ></el-input>
          </el-form-item>
          <div class="line"></div>
          <el-form-item label="客户姓名：" prop="customer">
            <el-input
              v-model="madeForm.customer"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="phone">
            <el-input
              v-model="madeForm.phone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="textarea">
            <el-input
              type="textarea"
              v-model="madeForm.textarea"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item>
          <div class="button">
            <span @click="onSubmit('madeForm')">发送定制需求</span>
          </div>
        </el-form>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{contactPhone}}</div>
      <div class="tel">邮件：{{contactEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>联系画院</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { orderSet,templePage,inheritorListByTemple } from "../../api/management.js";
export default {
  components: {
    PicTop,
  },
  data() {
    //验证手机号的正则表达式
    let reg =
      /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
    //验证方法
    let validatorPhone = function (phone, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      inheritorId: this.$route.query.inheritorId?this.$route.query.inheritorId:'',
      templeId: this.$route.query.templeId?this.$route.query.templeId:'',
      contactPhone:this.$route.query.phone?this.$route.query.phone:'18997193666',
      contactEmail:this.$route.query.email?this.$route.query.email:'regong_art_db@163.com',
      language: this.$store.state.language,
      paintingList: [],//画院列表
      inheritorList: [],
      madeForm: {
        customer: "",
        phone: "",
        category: "",
        theme: "",
        size: "",
        paintingId:'',//画院id
        // author: "",
        inheritorId: "",
        expectPrice: "",
        textarea: "",
      },
      rules: {
        customer: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        category: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        theme: [{ required: true, message: "请输入题材", trigger: "blur" }],
        size: [{ required: true, message: "请输入尺寸", trigger: "blur" }],
        // author: [{ required: true, message: "请输入作者", trigger: "blur" }],
        paintingId: [{ required: true, message: "请选择所属画院", trigger: "blur" }],
        inheritorId: [{ required: true, message: "请选择作者", trigger: "blur" }],
        expectPrice: [
          { required: true, message: "请输入预期价格", trigger: "blur" },
          { min: 1, max: 10, message: '价格长度在 1 到 10 个字符之间', trigger: 'blur' }
        ],
      },
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    this.getPaintingList()
  },
  methods: {
    // 获取画院列表
    async getPaintingList() {
      const res = await templePage({
        current: 1,
        pageSize: -1,
      });
      // console.log(res);
      if (res.code == 1) {
        this.paintingList = res.data.records;
        if(this.templeId) {
          // console.log(this.paintingList);
          this.madeForm.paintingId = Number(this.templeId)
          this.getInheritorList()
          this.madeForm.inheritorId = this.inheritorId?Number(this.inheritorId):''
        }
      }
    },
    // 获取传承人列表
    changePainting() {
      this.madeForm.inheritorId = ''
      if(this.madeForm.paintingId) {
        this.getInheritorList()
      }
    },
    async getInheritorList() {
      const res = await inheritorListByTemple(this.madeForm.paintingId);
      if (res.code == 1) {
        this.inheritorList = res.data
      }
    },
    handleInput(e) {
      let value = e.target.value;
      let reg = /^[1-9]{1}\d*/;   // 不能以0开头
      if(!reg.test(value)){
          e.target.value = '';
      }
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-' || key === '.' ) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    onSubmit(madeForm) {
      this.$refs[madeForm].validate(async (valid) => {
        if (valid) {
          const res = await orderSet(this.madeForm);
          if (res.code == 1) {
            this.$message({
              message: "定制成功",
              type: "success",
            });
            setTimeout(() => {
              this.$refs.madeForm.resetFields()
            }, 1000);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.exhibitionMade {
  position: relative;
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .image {
    position: relative;
    background: url("../../assets/newImageBgc/newImage_2.png") no-repeat center
      center;
    background-size: 100% 100%;
    height: 580px;
    .text {
      text-align: center;
      width: 2.5rem;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      color: #fff;
      font-size: 82px;
      font-family: "fangzang";
    }
    .za_text {
      font-size: 52px;
    }
    .eng_text {
      font-family: "Times New Roman", Times, serif;
      font-size: 78px;
    }
  }
  .exhibitionMadeTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .exhibitionMadeContent {
    position: relative;
    .section {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px 0;
      .madeForm {
        width: 800px;
        .el-form-item {
          .el-form-item__label {
            font-size: 16px !important;
          }
          .el-input,
          .el-select,
          .el-textarea {
            width: 600px;
            .el-input__inner {
              &::placeholder {
                font-family: "fangzang";
                font-size: 16px !important;
              }
              &::-webkit-input-placeholder {
                /* WebKit browsers 适配谷歌 */
                font-family: "fangzang";
                font-size: 16px !important;
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 适配火狐 */
                font-family: "fangzang";
                font-size: 16px !important;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ 适配火狐 */
                font-family: "fangzang";
                font-size: 16px !important;
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10+  适配ie*/
                font-family: "fangzang";
                font-size: 16px !important;
              }
            }
          }
        }
        .item {
          .el-input,
          .el-select,
          .el-textarea {
            width: 600px;
            //注意el-textarea里面的是el-input__inner
            .el-input__inner,
            .el-textarea__inner {
              &::placeholder {
                font-family: "Times New Roman", Times, serif;
                font-size: 16px !important;
              }
              &::-webkit-input-placeholder {
                /* WebKit browsers 适配谷歌 */
                font-family: "Times New Roman", Times, serif;
                font-size: 16px !important;
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 适配火狐 */
                font-family: "Times New Roman", Times, serif;
                font-size: 16px !important;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ 适配火狐 */
                font-family: "Times New Roman", Times, serif;
                font-size: 16px !important;
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10+  适配ie*/
                font-family: "Times New Roman", Times, serif;
                font-size: 16px !important;
              }
            }
          }
        }
        .button {
          padding-top: 20px;
          text-align: center;
          span {
            cursor: pointer;
            color: #fff;
            padding: 8px 10px;
            letter-spacing: 2px;
            border-radius: 3px;
            background-color: #971118;
            font-size: 24px;
            font-family: "fangzang";
          }
        }
        .line {
          border-bottom: 1px solid #f4f5f6;
          margin: 50px 0;
        }
      }
      .za_madeForm {
        .el-form-item__label {
          width: 186px !important;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      padding: 0 10px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      box-shadow: 0 0 10px #99131a;
      margin-bottom: 20px;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
  .cloudright {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
@media (max-width: 768px) {
  .exhibitionMade {
    background-position: 100% 100%;
    background-size: 15%;
    position: relative;
    .image {
      background: url("../../assets/newImage/mobile/topBgc/saleBgc.jpg")
        no-repeat center center;
      background-size: cover;
      height: 3.4rem;
      position: relative;
      .text {
        font-size: 0.5rem !important;
      }
      .za_text {
        font-size: 0.3rem !important;
      }
      .eng_text {
        font-family: "Times New Roman", Times, serif;
      }
    }
    .exhibitionMadeTop {
      position: relative;
      background: url("../../assets/newImage/index/could_left.png") no-repeat
        top left;
      background-position: 0 50%;
      background-size: 15%;
      .section {
        .section_left {
          left: 0.2rem;
        }
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
      }
      .moblieCloudLeft {
        position: absolute;
        top: 6%;
        left: 82%;
        width: 1.25rem;
      }
    }
    .exhibitionMadeContent {
      .section {
        padding: 8px 0;
        .madeForm {
          width: 100%;
          text-align: center;
          .el-form-item {
            margin-bottom: 0.46rem;
            .el-form-item__label {
              width: 2.6rem !important;
            }
            .el-form-item__content {
              .el-form-item__error {
                left: 4%;
              }
            }
            .el-input,
            .el-select,
            .el-textarea {
              width: 4.4rem;
            }
          }
          .line {
            margin: 0.3rem 0;
          }
          .button {
            padding-top: 0;
            margin-top: 1rem;
            margin-bottom: 0.4rem;
            span {
              font-size: 0.4rem;
            }
          }
          .eng_button {
            span {
              font-family: "Times New Roman", Times, serif;
            }
          }
        }
        .za_madeForm {
          .el-form-item {
            margin-bottom: 0.38rem;
            .el-form-item__label {
              width: 3.3rem !important;
              font-size: 0.28rem !important;
            }
            .el-input,
            .el-select,
            .el-textarea {
              width: 4rem;
              height: 0.8rem;
            }
          }
          .button {
            span {
              font-size: 0.3rem;
            }
          }
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 2%;
      right: 0;
      width: 1.25rem;
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.25rem;
    }
    .contact {
      right: 1%;
      z-index: 1000;
      bottom: 35%;
      .message {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
